import _ from "lodash";
import store from "services/redux/store";
import { setDataByGuid } from "services/redux/data/actions";
import { dataConstants } from "services/redux/data/constants";
import FetchCache from "utils/fetch/cached/FetchCache";
import HelperObject from 'utils/helper-object'
import FetchEmployeeConfidant from 'utils/fetch/FetchEmployeeConfidant'
import HelperDate, { dateFormat } from 'utils/helper-date'

export default class FetchCachedEmployeeConfidants
{
	static logName = 'FetchCachedEmployeeConfidants';
	static values = null;
	static cacheUpdatedAt = null;
	static isFetching = false;
	
	static construct = () => {
		return (
			FetchCache.initialize( this, {
				identifier: 'employee_confidants',
				tables: [ 'employee_confidants' ],
				onExpire: this.reload,
				updated_at_max_age: ( 5 * 60 ) // updated_at needs to be refresh at most each 5 minutes for this table (we also force a reload when a ero is opened)
			}, () => {
			} )
		);
	};
	
	
	static fetchAll = ( { callbackSuccess = null, callbackError = null, callbackStart = null } = {} ) => {
		this.construct().then( () =>
			{
			return (
				FetchCache.sniff( this.cacheUpdatedAt, {
					onFresh: () => {
						if( callbackSuccess !== null && _.isFunction( callbackSuccess ) ) {
							callbackSuccess({
								bookings: this.values,
							});
						}
					},
					onExpired: () => {
						this.reload( { callbackSuccess, callbackError, callbackStart } )
					}
				})
			);
		});
	}
	
	/**
	 * @param callbackSuccess
	 * @param callbackError
	 * @param callbackStart
	 */
	static reload = ( { callbackSuccess = null, callbackError = null, callbackStart = null } = {} ) => {
		this.construct().then( () => {
			if( this.isFetching === true ) {
				return;
			}
			
			FetchEmployeeConfidant.fetchAll({
				variables: {
					booking_date: [ HelperDate.date().format( dateFormat.DATE ) ],
					scanned_in_at: HelperDate.date().format( dateFormat.DATE ) +'_after'
				},
				callbackStart: () => {
					this.isFetching = true;
					if( _.isFunction( callbackStart ) ){
						callbackStart();
					}
				},
				callbackError: () => {
					this.isFetching = false;
					if( _.isFunction( callbackError ) ){
						callbackError();
					}
				},
				callbackSuccess: ( employees ) => {
					this.isFetching = false;
					employees = HelperObject.groupByGuid( employees );
					
					this.process( employees );
					
					if( _.isFunction( callbackSuccess ) ){
						callbackSuccess( employees );
					}
					
					// !! Employee eros are NOT stored on the users phone, we only use this cache for proper retrieval
					// FetchCache.storeData( this.cacheUpdatedAt, employees, true );
				}
			})
		});
	}
	
	static process = ( employees ) => {
		this.values = employees;
		store.dispatch( setDataByGuid( dataConstants.EMPLOYEES_CONFIDANTS, this.values ) );
		if( store.getState().data[ dataConstants.EMPLOYEES_CONFIDANTS_LOADED ] === false ){
			store.dispatch( setDataByGuid( dataConstants.EMPLOYEES_CONFIDANTS_LOADED, true ) );
		}
	}
}
